export class IFlotiqPluginEvent {
  constructor(initData?: object) {
    Object.assign(this, initData);
  }
}
